import {addLazyScroll} from 'app/components/toggle/utils/addLazyScroll';
import {ShouldSkipLazyLoadFn, ShouldSkipLazyLoadType} from 'app/interface';
import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {getLoadingType} from 'app/utils/initialize/getLoadingType';
import {shouldSkipLazyLoadNested} from 'app/utils/initialize/shouldSkipLazyLoadNested';
import {ToggleConfig} from 'interfaces/common/components/general/toggle/toggleConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn<ToggleConfig> = ({element, config}) => {
    if (!config?.items || config.items.length === 0) {
        return 'LOAD_LAZY';
    }

    const loadingTypes = new Set<ShouldSkipLazyLoadType>();

    config.items.forEach((item) => {
        try {
            addScrollDeeplinkItemAction({type: 'DEEPLINK', cId: item.cId, list: [item.cId]});

            const templateContent = element.parentElement?.querySelector<HTMLTemplateElement>(`template[data-cid="${item.cId}"]`)?.content;
            if (templateContent) {
                const nestedLoadingType = shouldSkipLazyLoadNested(templateContent);
                if (nestedLoadingType === 'LOAD_EAGER_WITH_SCROLL_TO') {
                    addScrollDeeplinkItemAction({type: 'LAZY_SCROLL', component: 'TOGGLE', cId: item.cId});
                }

                loadingTypes.add(nestedLoadingType);
            }

            if (addLazyScroll(item.cId)) {
                loadingTypes.add('LOAD_EAGER_WITH_SCROLL_TO');
            }
        } catch {
            loadingTypes.add('LOAD_LAZY');
        }
    });

    return getLoadingType(loadingTypes);
};
